const { parseSelectedFilters } = require('../../analyticUtils');
const { analyticsEventBus, ANALYTICS_EVENTS } = require('../../events');
const { createCustomEventGA4 } = require('../models/customEventGA4');
const { createEcommerceEventGA4 } = require('../models/ecommerceEventGA4');
const {
  createEcommerceEventItemsGA4,
} = require('../models/ecommerceEventItemsGA4');
const pushEvent = require('../pushEvent');
const { default: getFrontConfig } = require('../../../common/getFrontConfig');
const positionUtils = require('../utils/positionUtils');
const { impressionItemListStorage } = require('../../stores/itemList');
const createDebouncedEventBatchHandler = require('../../../common/utils/createDebouncedEventBatchHandler');

const {
  vue: {
    TheProductList: { columnMode },
  },
} = getFrontConfig();

/* -------------------------------------------------------------------------- *\
 * PLP EVENTS                                                                 *
 * ----------                                                                 *
 * - Banner image                                                             *
 * - Carousel                                                                 *
 * - Column mode                                                              *
 * - Filters                                                                  *
 * - Viewed                                                                   *
\* -------------------------------------------------------------------------- */

/**
 * Subscribe to our analytics events and push to dataLayers
 */
function subscribeToAnalyticsEvents() {
  // Banner image
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.productListBannerClicked,
    (payload) =>
      pushEvent(
        createCustomEventGA4('grid_banner_click', [['type', payload.type]])
      )
  );
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.productListBannerViewed,
    (payload) =>
      pushEvent(
        createCustomEventGA4('grid_banner_impression', [['type', payload.type]])
      )
  );

  // Carousel
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.productListBannerCarouselProductClicked,
    (payload) =>
      pushEvent(
        createCustomEventGA4('grid_carousel_click', [
          ['action', 'click'],
          ['position', positionUtils.oneBasedPosition(payload.position)],
        ])
      )
  );
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.productListBannerCarouselViewed,
    (payload) =>
      pushEvent(
        createCustomEventGA4('grid_carousel_impression', [
          ['action', 'impression'],
          ['position', positionUtils.oneBasedPosition(payload.position)],
        ])
      )
  );

  // Column mode
  const t = ANALYTICS_EVENTS.PAYLOADS.productListColumnModeClicked.columnMode;
  const typeToLabelMap = {
    [columnMode.compressed]: t.compressedView,
    [columnMode.default]: t.defaultView,
  };
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.productListColumnModeClicked,
    (type) =>
      pushEvent(
        createCustomEventGA4(typeToLabelMap[type], [['action', 'click']])
      )
  );

  // Filters
  analyticsEventBus.subscribe(
    [
      ANALYTICS_EVENTS.productListFiltersApplied,
      ANALYTICS_EVENTS.productListFiltersReset,
    ],
    (payload) =>
      pushEvent(
        createCustomEventGA4('grid_filters', [
          ['action', 'apply'],
          ['item', parseSelectedFilters(payload)],
        ])
      )
  );
  analyticsEventBus.subscribe(ANALYTICS_EVENTS.productListFiltersClosed, () =>
    pushEvent(createCustomEventGA4('grid_filters', [['action', 'close']]))
  );
  analyticsEventBus.subscribe(ANALYTICS_EVENTS.productListFiltersOpened, () =>
    pushEvent(createCustomEventGA4('grid_filters', [['action', 'open']]))
  );
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.productListViewedEmpty,
    ({ category }) =>
      pushEvent(
        createCustomEventGA4('grid_empty', [
          ['item', category.name],
          ['url', category.url],
        ])
      )
  );

  // Viewed PLP grids plus another ones like sliders...
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.productImpressionViewed,
    createDebouncedEventBatchHandler((payloads) => {
      const productsData = payloads.map(({ product }) => ({
        ...product,
        itemProps: {
          product_id_with_size: undefined,
        },
      }));
      pushEvent(
        createEcommerceEventGA4(
          'view_item_list',
          createEcommerceEventItemsGA4(productsData, {
            itemListStorage: impressionItemListStorage,
          })
        )
      );
    })
  );
}

module.exports = {
  subscribeToAnalyticsEvents,
};
